import { useWindowSize } from '@/hooks';
import { Layout } from 'antd';
import logoMin from '@/assets/images/Logo-UC-mobile.png';
import logo from '@/assets/images/Logo_Footer.png';
import { Link } from 'react-router-dom';
import { isAppPortocar } from '@/index';

const LayoutPublicHeader: React.FC = () => {
  const { isMobile } = useWindowSize();

  return (
    <Layout.Header className="app-header">
      <div className="app-header-content" style={{ maxWidth: '100%' }}>
        {isMobile ? (
          <div className="logoMin">
            <Link to="/">
              <img
                className="image"
                src={
                  isAppPortocar
                    ? '/images/Logo_PortoCar_branca-icon.svg'
                    : logoMin
                }
                alt="logo"
                style={{ width: '60px' }}
              />
            </Link>
          </div>
        ) : (
          <div className="logo">
            <Link to="/">
              <img
                className="image"
                src={isAppPortocar ? '/images/Logo_PortoCar_branca.svg' : logo}
                alt="logo"
                style={{ height: '60%' }}
              />
            </Link>
          </div>
        )}
      </div>
    </Layout.Header>
  );
};

export default LayoutPublicHeader;
